import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_FORMULARIO_URL,
});

const apiSystem = axios.create({
  baseURL: process.env.REACT_APP_API_SISTEMA_URL,
});

api.interceptors.response.use(
  function successRequest(response) {
    return response;
  },
  async function errorRequest(error) {
    try {
      if (error.message === "Network Error" || error.status === 500) {
        apiSystem.post(`/clientForms/form/warning`, {
          url: error.config.url,
        });
        const originalRequest = error.config;

        const res = await apiSystem({
          ...originalRequest,
          baseURL: process.env.REACT_APP_API_SISTEMA_URL,
        });

        return res;
      }
      return Promise.reject(error);
    } catch {
      return Promise.reject(error);
    }
  }
);
export { api };
